/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import moment from 'moment';
import AvailableOn from './AvailableOn';
import SelectInput from '../../../../stories/Inputs/SelectInput';
import LocationOption from '../../../../_components/Options/LocationOption';
import ReactDatePicker from '../../../../_components/DatePicker/ReactDatePicker';
import ProfessionalOption from '../../../../_components/Options/ProfessionalOption';
import PreVisitQuestionOption from '../../../../_components/Options/PreVisitQuestionOption'
import RenderValidateMessage from '../../../../stories/Validation/RenderValidateMessage';

import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export default function AddTelehealthModal(
  {
    show,
    hide,
    loading = false,
    addEventItem,
    groupSelected = "",
    appointmentDate = "",
    providerSelected = "",
    preVisitQuestionsSelected = "",
  }
) {

  const [type, setType] = useState("");
  const [errors, setErrors] = useState({});
  const [doctor, setDoctor] = useState(providerSelected);
  const [appointment, setAppointment] = useState("");
  const [availableOn, setAvailableOn] = useState("");
  const [providerGroup, setProviderGroup] = useState(groupSelected);
  const [preVisitQuestions, setPreVisitQuestions] = useState(preVisitQuestionsSelected)

  useEffect(() => {
    handleShow();
  }, [show])

  const handleShow = () => {
    setErrors({});
    setDoctor(providerSelected);
    setAppointment("");
    setAvailableOn("");
    setProviderGroup(groupSelected);
    setPreVisitQuestions(preVisitQuestionsSelected);
  }

  const validate = (e) => {
    e.preventDefault();

    let errors = {};

    if (!type) {
      errors.type = 'Telehealth Type is required.'
    }

    if (!appointment) {
      errors.dateTime = 'Telehealth Date is required.'
    } else if (moment(appointment).isBefore(new Date())) {
      errors.dateTime = 'Telehealth Date must be upcoming.';
    }

    if (!providerGroup.value) {
      errors.providerGroup = 'Location is required.'
    }

    if (!doctor.value) {
      errors.doctor = 'Provider is required.'
    }

    if (!preVisitQuestions.value) {
      errors.questions = 'Pre-Visit Questions is required.'
    }

    if (availableOn && moment(availableOn).isSameOrBefore(moment())) {
      errors.availableOn = 'Available On must be an upcoming date.';
    }

    if (availableOn && appointment && moment(availableOn).isSameOrAfter(moment(appointment))) {
      errors.availableOn = 'Available On must be before appointment date.';
    }

    setErrors(errors);

    if (!errors.type && !errors.dateTime && !errors.doctor && !errors.providerGroup && !errors.questions && !errors.availableOn) {
      addTelehealth();
    }
  }

  const addTelehealth = () => {
    const telehealth = {
      type: 'Telehealth',
      doctor: { id: doctor.value, name: doctor.label },
      date: moment(appointment).format("LLL"),
      availableOn: availableOn ? moment(availableOn).format("LLL") : 'Immediately',
      providerGroup: { id: providerGroup.value, name: providerGroup.label },
      telehealthType: type,
      preVisitQuestions: { id: preVisitQuestions.value, name: preVisitQuestions.label },
    }
    addEventItem(telehealth);
    clearAndHideTelehealth();
  }

  const clearAndHideTelehealth = () => {
    setType("");
    setErrors({});
    setDoctor("");
    setAppointment("");
    setAvailableOn("");
    setProviderGroup("");
    setPreVisitQuestions("");
    hide();
  }

  return (
    <Modal show={show} onHide={clearAndHideTelehealth}>
      <Modal.Header closeButton>
        <Modal.Title>Add Telehealth</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="form-providerGroup mb-4">
            <div className="row">
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Provider</label>
                <ProfessionalOption defaultValue={doctor.value} handleSelected={(value, label) => setDoctor({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="doctor" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Location</label>
                <LocationOption defaultValue={providerGroup.value} handleSelected={(value, label) => setProviderGroup({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="providerGroup" />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Pre-Visit Questions</label>
                <PreVisitQuestionOption defaultValue={preVisitQuestions.value} handleSelected={(value, label) => setPreVisitQuestions({ value: value, label: label })} />
                <RenderValidateMessage errors={errors} field="questions" />
              </div>
              <div className="col-sm-12 mb-2">
                <SelectInput
                  value={type}
                  label="Telehealth Type"
                  errors={errors}
                  options={[{ value: 'video', label: 'Real Time' }, { value: 'messaging', label: 'Asynchronous' }]}
                  setValue={(value) => setType(value.type)}
                  required={true}
                  valueName="type"
                  placeholder="Select..."
                />
              </div>
              <div className="col-sm-12 mb-4">
                <label><span className="text-danger">*</span> Telehealth Appointment Date</label>
                <ReactDatePicker
                  selected={appointment}
                  onChange={(date) => setAppointment(date)}
                  minDate={new Date()}
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={5}
                  dateFormat="MMM d, yyyy h:mm aa"
                  className="form-control"
                  wrapperClassName="w-100"
                />
                <RenderValidateMessage errors={errors} field="dateTime" />
              </div>
              <div className="col-sm-12">
                <AvailableOn
                  sendOn={availableOn}
                  noMinTime={true}
                  noMaxTime={true}
                  setAvailableOn={(date) => setAvailableOn(date)}
                  apptDate={appointment}
                  apptType="telehealth"
                />
                <RenderValidateMessage errors={errors} field="availableOn" />
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={validate} disabled={loading}>
          {loading ? 'Adding...' : 'Add Telehealth'}
        </Button>
        <Button variant="secondary" onClick={clearAndHideTelehealth}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
